import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SocialPostSchedulePanelProps} from '@Panels/social-post-schedule-panel/social-post-schedule-panel.types';

export const openSocialPostScheduleModal = (props: SocialPostSchedulePanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_POST_SCHEDULE_MODAL,
      panelProps: {...props},
    })
  );
};
